import { clsx } from "clsx"
import { forwardRef, useState, useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons"
import "@/assets/css/input.css"
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons"

const Input = forwardRef(({ required = false, shouldUseEnterKeyHint = false, type, placeholder, name, id, label, custCls, custLabelCls, errMsg = "", borderColor, spinner = false, comingSoonForm = false, noLabel = false, isCart = false, isInput1 = false, isInput2 = false, hasIcon = false, noValue = false, disabled = false, defaultVal = 0, onInputVal = () => { }, onKeyPress = () => { }, onKeyRelease = () => { }, calculateQuantityVal = () => { } }, ref) => {
  const [props, useProps] = useState(noValue ? {} : { value: 0 })
  const [propsNumber, usePropsNumber] = useState(type == "number" ? { defaultValue: 1 } : {})

  useEffect(() => {
    if (defaultVal) useProps({ value: defaultVal })
  }, [defaultVal])

  const handleInputVal = (e) => {
    onInputVal(e.target.value)
  }

  const handleKeyDown = (e) => {
    onKeyPress(e)
  }

  const handleKeyUp = (e) => {
    onKeyRelease(e)
  }

  const calculateQuantity = (add) => {
    calculateQuantityVal(add)
  }

  return (
    <>
      {/* input for coming soon */}
      {comingSoonForm && (
        <>
          <input required={required} type={type} placeholder={placeholder} name={name} id={id} className={clsx("border-[1.5px] border-[#6c5f58] font-agcasmlt font-light text-sm sm:text-xl px-3 sm:px-4 py-2 focus:outline-none w-full", custCls)} {...ref} />
          {errMsg && (
            <span className="text-[10px] sm:text-[12px] text-red-600">{errMsg}</span>
          )}
        </>
      )}
      {(isInput1 || isInput2) && (
        <>
          {!noLabel && (
            <label className={clsx("font-agcasmlt font-light text-[#6d625a] inline-block", custLabelCls)}>{label}</label>
          )}
          <div className={clsx({ "relative": hasIcon })}>
            <input onInput={handleInputVal} onKeyDown={handleKeyDown} onKeyUp={handleKeyUp} disabled={disabled} required={required} type={type} placeholder={placeholder} name={name} id={id} className={clsx("border-[1.5px] border-[#6d625a] font-agcasmlt font-light text-base placeholder-[#9f978e] pt-2 px-2 focus:outline-none w-full", { "h-[2.15rem]": isInput1, "h-10 pb-1": isInput2, "bg-transparent": !disabled, "text-[#4d4d4d] cursor-not-allowed": disabled }, custCls, borderColor)} {...ref} {...propsNumber} {...(shouldUseEnterKeyHint ? { enterKeyHint: "go" } : {})} />
            {hasIcon && (
              <span className="absolute right-2 top-1/2 -translate-y-1/2">
                <button type="button">
                  <FontAwesomeIcon icon={faCircleQuestion} size="xs" style={{ color: "#6d625a" }} />
                </button>
              </span>
            )}
          </div>
          {errMsg && (
            <span className="text-[10px] sm:text-[12px] text-red-600">{errMsg}</span>
          )}
        </>
      )}
      {/* Spinner */}
      {/* TODO: belum isi class yg bikin kursornya disabled gitu tampilannya, yg lingakran merah isi garis miring tu */}
      {spinner && (
        <div>
          {!noLabel && (
            <label className="font-light font-agcasmlt text-sm sm:text-xl text-[#6e6060]">Quantity</label>
          )}
          {/* spinner */}
          <div className={clsx("relative", custCls)}>
            <button type="button" disabled={disabled} onClick={() => calculateQuantity(-1)} className="text-[#6e6060] font-light absolute top-1/2 -translate-y-1/2 left-3">
              <FontAwesomeIcon icon={faMinus} size="xs" />
            </button>
            <input disabled={disabled} onInput={handleInputVal} type="number" min="0" name="quantity" id="quantity" className="h-[2.5rem] md:h-[3rem] w-full border-2 border-[#dcd6d2] text-[#6e6060] font-light font-agcasmlt text-lg sm:text-xl lg:text-2xl pt-2 pb-1 text-center block focus:outline-none" {...ref} {...props} />
            <button type="button" disabled={disabled} onClick={() => calculateQuantity(1)} className="text-[#6e6060] font-light absolute bottom-1/2 translate-y-1/2 right-3">
              <FontAwesomeIcon icon={faPlus} size="xs" />
            </button>
          </div>
        </div>
      )}
      {isCart && (
        <input required={required} type={type} placeholder={placeholder} name={name} id={id} className={clsx("w-full border-2 border-[#dcd6d2] text-[#6e6060] font-normal font-agcasmlt text-sm sm:text-xl focus:outline-none", custCls)} />
      )}
    </>
  )
})

export default Input